import type { Theme } from "@material-ui/core";
import { Chip as MuiChip, createStyles, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles<Theme, ThemeProps>((theme) =>
  createStyles({
    chip: {
      height: "18px",
      maxWidth: "60px",
      backgroundColor: ({ bgColor }) => bgColor ?? theme.palette.secondary.light,
      fontWeight: 400,
      padding: 0,
    },
    label: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    chipValue: {
      color: ({ textColor }) => textColor ?? theme.palette.primary.dark,
      fontSize: "12px",
    },
  }),
);

interface ThemeProps {
  bgColor?: string;
  textColor?: string;
}

export interface ChipProps extends ThemeProps {
  text: string;
}

const Chip = ({ text, bgColor, textColor }: ChipProps): JSX.Element => {
  const classes = useStyles({ bgColor, textColor });
  return (
    <MuiChip
      classes={{ root: classes.chip, label: classes.label }}
      label={
        <Typography noWrap className={classes.chipValue}>
          {text}
        </Typography>
      }
    />
  );
};

export default Chip;
